<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.125 8C14.125 7.70206 14.1038 7.40959 14.0629 7.1239C13.6385 4.15646 11.0849 1.875 8 1.875C5.91934 1.875 4.08067 2.91165 2.97235 4.50059C2.69589 4.89694 2.15046 4.99413 1.7541 4.71766C1.35775 4.4412 1.26056 3.89577 1.53703 3.49941C2.9586 1.46138 5.32317 0.125 8 0.125C11.968 0.125 15.2493 3.05895 15.7953 6.8761C15.8479 7.24362 15.875 7.6189 15.875 8C15.875 8.48325 15.4832 8.875 15 8.875C14.5168 8.875 14.125 8.48325 14.125 8ZM13.5519 10.5929L15.1167 11.3755C15.0255 11.5675 14.9268 11.7551 14.8209 11.9381C13.4606 14.2897 10.916 15.875 8 15.875C3.65076 15.875 0.125 12.3492 0.125 8C0.125 7.51675 0.516751 7.125 1 7.125C1.48325 7.125 1.875 7.51675 1.875 8C1.875 11.3827 4.61726 14.125 8 14.125C10.2599 14.125 12.2351 12.9015 13.2975 11.0767L13.5519 10.5929Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.45455 0.25C1.86876 0.25 2.20455 0.585786 2.20455 1V5C2.20455 5.41421 1.86876 5.75 1.45455 5.75C1.04033 5.75 0.704545 5.41421 0.704545 5V1C0.704545 0.585786 1.04033 0.25 1.45455 0.25Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.70453 4.99835C5.7055 5.41256 5.37051 5.74913 4.95629 5.7501L1.4563 5.75831C1.04209 5.75928 0.705518 5.42428 0.704548 5.01007C0.703577 4.59586 1.03858 4.25928 1.45279 4.25831L4.95278 4.25011C5.36699 4.24914 5.70356 4.58414 5.70453 4.99835Z"
      :fill="color"
    />
    <path
      d="M10.9524 10.2541C10.5381 10.2551 10.2031 10.5916 10.2041 11.0058C10.2051 11.4201 10.5417 11.7551 10.9559 11.7541L13.7041 11.7476L13.7041 15.0042C13.7041 15.4184 14.0399 15.7542 14.4541 15.7542C14.8683 15.7542 15.2041 15.4184 15.2041 15.0042L15.2041 11.0042L15.2041 11L15.2041 10.9941C15.2031 10.5799 14.8666 10.2449 14.4523 10.2459L10.9524 10.2541Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ProgressIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
